/** @format */

import React, { useEffect } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next/hooks';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { isValidPhoneNumber } from 'react-phone-number-input';

import TopSection from '../TopSection/TopSection';
import SimpleReactValidator from 'simple-react-validator';
import PhoneInput from 'react-phone-input-2';

import 'react-phone-input-2/lib/high-res.css';

function Contact({
	match: {
		params: { id },
	},
}) {
	const [t] = useTranslation('translation');

	const service = useStoreActions((actions) => actions.contact);
	const data = useStoreState((state) => state.contact);
	const bookingData = useStoreState((state) => state.cart);
	const bookingService = useStoreActions((actions) => actions.cart);

	const validator = new SimpleReactValidator({
		className: 'validationMessage',
		validators: {
			nameValidator: {
				rule: (val, params, validator) => {
					return true; //validator.helpers.testRegex(val, /^[\p{L}'][ \p{L}',.-]*[ \p{L}',.-]$/u) && params.indexOf(val) === -1;
				},
			},
			carLengthValidator: {
				rule: (val, params, validator) => {
					return validator.helpers.testRegex(val, /^([1-9]|1[0-9]|2[0-5])([,.]\d+)?$/);
				},
			},
			phoneValidator: {
				rule: (val, params, validator) => {
					let { num, country } = val;
					var isValid = isValidPhoneNumber(num, country?.toUpperCase());
					return isValid;
				},
			},
		},
		messages: {
			alpha_num_dash_space: t('Invalid'),
			carLengthValidator: t('carLengthError'),
			required: t('Mandatory'),
			default: t('Invalid'),
		},
	});

	useEffect(() => {
		validator.showMessageFor('Navn');
		validator.showMessageFor('errorEmail');
		validator.showMessageFor('errorLPN');
		validator.showMessageFor('errorPhone');
		validator.showMessageFor('carLength');
		validator.showMessageFor('Checkbox');
		validator.showMessages();

		service.setTermsAcceptedError(validator.errorMessages['Checkbox']);
	});

	if (bookingData.travelOut === null) {
		return <Redirect to={'/'} />;
	}

	return (
		<div>
			<section>
				<TopSection />
			</section>
			<section>
				<div className='linkandheading'>
					<Link to={'/TravelsSelect/' + id}></Link>
					<h1>{t('contact')}</h1>
					<Link to='/'></Link>
				</div>

				<div className='with-label'>
					<label>{t('name')}</label>
					<input
						type='text'
						value={data.Name}
						name='name'
						onBlur={() => service.setNameError(validator.errorMessages['Navn'])}
						onChange={(e) => service.setName(e.target.value)}
						isvalid={data.NameError === null ? 'true' : 'false'}
					/>
					{validator.message('Navn', data.Name, 'required|nameValidator')}
					<div className='validationMessage' style={{ display: data.NameError === null ? 'none' : 'block' }}>
						{data.NameError}
					</div>
				</div>
				<div className='with-label'>
					<label>
						{t('yourEmail')} <i>({t('toSendYouTheTickets')})</i>
					</label>
					<input
						placeholder='example@mail.com'
						value={data.Email}
						name='email'
						type='text'
						onBlur={() => service.setEmailError(validator.errorMessages['Epost'])}
						onChange={(e) => service.setEmail(e.target.value)}
						isvalid={data.EmailError === null ? 'true' : 'false'}
					/>
					{validator.message('Epost', data.Email, 'email|required')}
					<div className='validationMessage' style={{ display: data.EmailError === null ? 'none' : 'block' }}>
						{data.EmailError}
					</div>
				</div>
				<div className='with-label'>
					<label>{t('yourPhone')}</label>
					<PhoneInput
						buttonClass='phoneButton'
						dropdownClass='phone'
						inputClass='phone'
						country={'no'}
						preferredCountries={['no', 'se', 'dk', 'us', 'cn']}
						value={data.PhoneNumber}
						onChange={(value, data) => service.setPhone({ Number: value, Data: data })}
						onBlur={() => service.setPhoneError(data.PhoneNumberRaw ? validator.errorMessages['Phone'] : null)}
						isValid={() => data.PhoneNumberError === null}
					/>
					{validator.message(
						'Phone',
						{ num: data.PhoneNumber, country: data.PhoneData?.countryCode },
						'required|phoneValidator'
					)}
					<div className='validationMessage' style={{ display: data.PhoneNumberError === null ? 'none' : 'block' }}>
						{data.PhoneNumberError}
					</div>
				</div>
				{data.IsSmsSupported ? (
					<div className='with-label horizontal'>
						<div className='customCheckBox'>
							<input
								type='checkbox'
								checked={data.SmsAccepted}
								onChange={(e) => service.setSmsAccepted(e.target.checked)}
							/>
							<span className='checkmark'></span>
						</div>
						<label>{t('acceptSms')}</label>
					</div>
				) : (
					<div className='with-label'>
						<i>{t('smsOnlyNorwegianNumbers')}</i>
					</div>
				)}
				<div className='with-label'>
					<label>{t('licensePlate')}</label>
					<input
						type='text'
						value={data.LPN}
						placeholder='AB12345'
						name='lpn'
						onBlur={() => service.setLPNError(validator.errorMessages['LPN'])}
						onChange={(e) => service.setLPN(e.target.value)}
						isvalid={data.LPNError === null ? 'true' : 'false'}
					/>
					{validator.message('LPN', data.LPN, 'required|nameValidator')}
					<div className='validationMessage' style={{ display: data.LPNError === null ? 'none' : 'block' }}>
						{data.LPNError}
					</div>
				</div>
				<div className='with-label'>
					<label>{t('carLength')}</label>
					<input
						type='text'
						value={data.CarLength}
						placeholder='0,0'
						name='carLength'
						onBlur={() => service.setCarLengthError(validator.errorMessages['carLength'])}
						onChange={(e) => service.setCarLength(e.target.value)}
						isvalid={data.CarLengthError === null ? 'true' : 'false'}
					/>
					{validator.message('carLength', data.CarLength, 'required|carLengthValidator')}
					<div className='validationMessage' style={{ display: data.CarLengthError === null ? 'none' : 'block' }}>
						{data.CarLengthError}
					</div>
				</div>
				<div className={'verticalSpace28'}></div>
				<div className='with-label horizontal'>
					<div className='customCheckBox' isvalid={data.TermsAcceptedError === null ? 'true' : 'false'}>
						<input
							type='checkbox'
							checked={data.TermsAccepted}
							onChange={(e) => service.setTermsAccepted(e.target.checked)}
						/>
						<span className='checkmark'></span>
					</div>
					<label>
						<a href={`${process.env.PUBLIC_URL}/Terms`} target='_new' title={t('opensInNewTab')}>
							{t('acceptTerms')}
						</a>
					</label>
					{validator.message('Checkbox', data.TermsAccepted, 'accepted|required')}
				</div>
				<div className={'verticalSpace28'} />
				<Link
					to='/payment'
					onClick={() => {
						bookingService.setContactPerson(data);
					}}
					className={validator.allValid() ? 'btn_default' : 'btn_default disabled'}
				>
					{t('toPayment')}
				</Link>
			</section>
		</div>
	);
}

export default Contact;
